import { GlobalWebBrandingStyles } from 'pricing-pages-ui-components/stylesheets/GlobalWebBranding.styles';
import { useWebTeamBranding } from '../utils/brandingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalWebBrandingStylesContainer = () => {
  const useBranding = useWebTeamBranding();
  return useBranding ? /*#__PURE__*/_jsx(GlobalWebBrandingStyles, {}) : null;
};